/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfBoolean } from '../models/platform-api-result-of-boolean';
import { PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto } from '../models/platform-api-result-of-data-source-result-dto-of-feedback-summary-dto';
import { PlatformApiResultOfFeedbackAttachmentContentDto } from '../models/platform-api-result-of-feedback-attachment-content-dto';
import { PlatformApiResultOfFeedbackDetailDto } from '../models/platform-api-result-of-feedback-detail-dto';
import { PlatformApiResultOfFeedbackUnreadCountDto } from '../models/platform-api-result-of-feedback-unread-count-dto';
import { PlatformApiResultOfInteger } from '../models/platform-api-result-of-integer';
import { getFeedbackAttachmentsId } from '../fn/feedback/get-feedback-attachments-id';
import { GetFeedbackAttachmentsId$Params } from '../fn/feedback/get-feedback-attachments-id';
import { getFeedbackManageId } from '../fn/feedback/get-feedback-manage-id';
import { GetFeedbackManageId$Params } from '../fn/feedback/get-feedback-manage-id';
import { getFeedbackManageUnreadCount } from '../fn/feedback/get-feedback-manage-unread-count';
import { GetFeedbackManageUnreadCount$Params } from '../fn/feedback/get-feedback-manage-unread-count';
import { getFeedbackMineId } from '../fn/feedback/get-feedback-mine-id';
import { GetFeedbackMineId$Params } from '../fn/feedback/get-feedback-mine-id';
import { getFeedbackMineUnreadCount } from '../fn/feedback/get-feedback-mine-unread-count';
import { GetFeedbackMineUnreadCount$Params } from '../fn/feedback/get-feedback-mine-unread-count';
import { postFeedbackActionCreate } from '../fn/feedback/post-feedback-action-create';
import { PostFeedbackActionCreate$Params } from '../fn/feedback/post-feedback-action-create';
import { postFeedbackManageActionComment } from '../fn/feedback/post-feedback-manage-action-comment';
import { PostFeedbackManageActionComment$Params } from '../fn/feedback/post-feedback-manage-action-comment';
import { postFeedbackManageActionMarkSeen } from '../fn/feedback/post-feedback-manage-action-mark-seen';
import { PostFeedbackManageActionMarkSeen$Params } from '../fn/feedback/post-feedback-manage-action-mark-seen';
import { postFeedbackManageActionSetPriority } from '../fn/feedback/post-feedback-manage-action-set-priority';
import { PostFeedbackManageActionSetPriority$Params } from '../fn/feedback/post-feedback-manage-action-set-priority';
import { postFeedbackManageActionSetStatus } from '../fn/feedback/post-feedback-manage-action-set-status';
import { PostFeedbackManageActionSetStatus$Params } from '../fn/feedback/post-feedback-manage-action-set-status';
import { postFeedbackManageQueryDatasource } from '../fn/feedback/post-feedback-manage-query-datasource';
import { PostFeedbackManageQueryDatasource$Params } from '../fn/feedback/post-feedback-manage-query-datasource';
import { postFeedbackMineActionComment } from '../fn/feedback/post-feedback-mine-action-comment';
import { PostFeedbackMineActionComment$Params } from '../fn/feedback/post-feedback-mine-action-comment';
import { postFeedbackMineActionMarkAllSeen } from '../fn/feedback/post-feedback-mine-action-mark-all-seen';
import { PostFeedbackMineActionMarkAllSeen$Params } from '../fn/feedback/post-feedback-mine-action-mark-all-seen';
import { postFeedbackMineActionMarkSeen } from '../fn/feedback/post-feedback-mine-action-mark-seen';
import { PostFeedbackMineActionMarkSeen$Params } from '../fn/feedback/post-feedback-mine-action-mark-seen';
import { postFeedbackMineQueryDatasource } from '../fn/feedback/post-feedback-mine-query-datasource';
import { PostFeedbackMineQueryDatasource$Params } from '../fn/feedback/post-feedback-mine-query-datasource';


/**
 * Support-meldingen. mine/* werkt in melder-scope (eigen meldingen),
 * manage/* in beheerscope; de scope wordt hier gezet, nooit uit de body gelezen.
 */
@Injectable({ providedIn: 'root' })
export class PlatformFeedbackService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postFeedbackActionCreate()` */
  static readonly PostFeedbackActionCreatePath = '/api/feedback/action/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackActionCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackActionCreate$Response(params: PostFeedbackActionCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
    return postFeedbackActionCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackActionCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackActionCreate(params: PostFeedbackActionCreate$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackDetailDto> {
    return this.postFeedbackActionCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>): PlatformApiResultOfFeedbackDetailDto => r.body)
    );
  }

  /** Path part for operation `postFeedbackMineQueryDatasource()` */
  static readonly PostFeedbackMineQueryDatasourcePath = '/api/feedback/mine/query/datasource';

  /**
   * Eigen meldingen, gepagineerd: zoeken en paging via de DataSourceQuery, statussen, type en
   * (on)gelezen als vaste filters. Zonder SortOptions: recentste activiteit eerst.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackMineQueryDatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackMineQueryDatasource$Response(params: PostFeedbackMineQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto>> {
    return postFeedbackMineQueryDatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * Eigen meldingen, gepagineerd: zoeken en paging via de DataSourceQuery, statussen, type en
   * (on)gelezen als vaste filters. Zonder SortOptions: recentste activiteit eerst.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackMineQueryDatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackMineQueryDatasource(params: PostFeedbackMineQueryDatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto> {
    return this.postFeedbackMineQueryDatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto>): PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto => r.body)
    );
  }

  /** Path part for operation `getFeedbackMineId()` */
  static readonly GetFeedbackMineIdPath = '/api/feedback/mine/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbackMineId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackMineId$Response(params: GetFeedbackMineId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
    return getFeedbackMineId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedbackMineId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackMineId(params: GetFeedbackMineId$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackDetailDto> {
    return this.getFeedbackMineId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>): PlatformApiResultOfFeedbackDetailDto => r.body)
    );
  }

  /** Path part for operation `postFeedbackMineActionComment()` */
  static readonly PostFeedbackMineActionCommentPath = '/api/feedback/mine/action/comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackMineActionComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackMineActionComment$Response(params: PostFeedbackMineActionComment$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
    return postFeedbackMineActionComment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackMineActionComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackMineActionComment(params: PostFeedbackMineActionComment$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackDetailDto> {
    return this.postFeedbackMineActionComment$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>): PlatformApiResultOfFeedbackDetailDto => r.body)
    );
  }

  /** Path part for operation `postFeedbackMineActionMarkSeen()` */
  static readonly PostFeedbackMineActionMarkSeenPath = '/api/feedback/mine/action/mark-seen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackMineActionMarkSeen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackMineActionMarkSeen$Response(params: PostFeedbackMineActionMarkSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postFeedbackMineActionMarkSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackMineActionMarkSeen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackMineActionMarkSeen(params: PostFeedbackMineActionMarkSeen$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postFeedbackMineActionMarkSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postFeedbackMineActionMarkAllSeen()` */
  static readonly PostFeedbackMineActionMarkAllSeenPath = '/api/feedback/mine/action/mark-all-seen';

  /**
   * Alle eigen ongelezen meldingen als gelezen markeren zonder ze te openen; levert het aantal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackMineActionMarkAllSeen()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeedbackMineActionMarkAllSeen$Response(params?: PostFeedbackMineActionMarkAllSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfInteger>> {
    return postFeedbackMineActionMarkAllSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * Alle eigen ongelezen meldingen als gelezen markeren zonder ze te openen; levert het aantal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackMineActionMarkAllSeen$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeedbackMineActionMarkAllSeen(params?: PostFeedbackMineActionMarkAllSeen$Params, context?: HttpContext): Observable<PlatformApiResultOfInteger> {
    return this.postFeedbackMineActionMarkAllSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfInteger>): PlatformApiResultOfInteger => r.body)
    );
  }

  /** Path part for operation `getFeedbackMineUnreadCount()` */
  static readonly GetFeedbackMineUnreadCountPath = '/api/feedback/mine/unread-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbackMineUnreadCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackMineUnreadCount$Response(params?: GetFeedbackMineUnreadCount$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackUnreadCountDto>> {
    return getFeedbackMineUnreadCount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedbackMineUnreadCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackMineUnreadCount(params?: GetFeedbackMineUnreadCount$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackUnreadCountDto> {
    return this.getFeedbackMineUnreadCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackUnreadCountDto>): PlatformApiResultOfFeedbackUnreadCountDto => r.body)
    );
  }

  /** Path part for operation `getFeedbackAttachmentsId()` */
  static readonly GetFeedbackAttachmentsIdPath = '/api/feedback/attachments/{id}';

  /**
   * Bijlage-inhoud; toegankelijk voor de melder en voor beheerders (check in de handler).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbackAttachmentsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackAttachmentsId$Response(params: GetFeedbackAttachmentsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackAttachmentContentDto>> {
    return getFeedbackAttachmentsId(this.http, this.rootUrl, params, context);
  }

  /**
   * Bijlage-inhoud; toegankelijk voor de melder en voor beheerders (check in de handler).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedbackAttachmentsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackAttachmentsId(params: GetFeedbackAttachmentsId$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackAttachmentContentDto> {
    return this.getFeedbackAttachmentsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackAttachmentContentDto>): PlatformApiResultOfFeedbackAttachmentContentDto => r.body)
    );
  }

  /** Path part for operation `postFeedbackManageQueryDatasource()` */
  static readonly PostFeedbackManageQueryDatasourcePath = '/api/feedback/manage/query/datasource';

  /**
   * Alle meldingen, gepagineerd: zoeken en paging via de DataSourceQuery, statussen, type en
   * (on)gelezen als vaste filters. Zonder SortOptions: prioriteit eerst, dan recentste activiteit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackManageQueryDatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageQueryDatasource$Response(params: PostFeedbackManageQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto>> {
    return postFeedbackManageQueryDatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * Alle meldingen, gepagineerd: zoeken en paging via de DataSourceQuery, statussen, type en
   * (on)gelezen als vaste filters. Zonder SortOptions: prioriteit eerst, dan recentste activiteit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackManageQueryDatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageQueryDatasource(params: PostFeedbackManageQueryDatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto> {
    return this.postFeedbackManageQueryDatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto>): PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto => r.body)
    );
  }

  /** Path part for operation `getFeedbackManageId()` */
  static readonly GetFeedbackManageIdPath = '/api/feedback/manage/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbackManageId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackManageId$Response(params: GetFeedbackManageId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
    return getFeedbackManageId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedbackManageId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackManageId(params: GetFeedbackManageId$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackDetailDto> {
    return this.getFeedbackManageId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>): PlatformApiResultOfFeedbackDetailDto => r.body)
    );
  }

  /** Path part for operation `postFeedbackManageActionComment()` */
  static readonly PostFeedbackManageActionCommentPath = '/api/feedback/manage/action/comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackManageActionComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageActionComment$Response(params: PostFeedbackManageActionComment$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
    return postFeedbackManageActionComment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackManageActionComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageActionComment(params: PostFeedbackManageActionComment$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackDetailDto> {
    return this.postFeedbackManageActionComment$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>): PlatformApiResultOfFeedbackDetailDto => r.body)
    );
  }

  /** Path part for operation `postFeedbackManageActionSetStatus()` */
  static readonly PostFeedbackManageActionSetStatusPath = '/api/feedback/manage/action/set-status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackManageActionSetStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageActionSetStatus$Response(params: PostFeedbackManageActionSetStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
    return postFeedbackManageActionSetStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackManageActionSetStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageActionSetStatus(params: PostFeedbackManageActionSetStatus$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackDetailDto> {
    return this.postFeedbackManageActionSetStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>): PlatformApiResultOfFeedbackDetailDto => r.body)
    );
  }

  /** Path part for operation `postFeedbackManageActionSetPriority()` */
  static readonly PostFeedbackManageActionSetPriorityPath = '/api/feedback/manage/action/set-priority';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackManageActionSetPriority()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageActionSetPriority$Response(params: PostFeedbackManageActionSetPriority$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
    return postFeedbackManageActionSetPriority(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackManageActionSetPriority$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageActionSetPriority(params: PostFeedbackManageActionSetPriority$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackDetailDto> {
    return this.postFeedbackManageActionSetPriority$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>): PlatformApiResultOfFeedbackDetailDto => r.body)
    );
  }

  /** Path part for operation `postFeedbackManageActionMarkSeen()` */
  static readonly PostFeedbackManageActionMarkSeenPath = '/api/feedback/manage/action/mark-seen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeedbackManageActionMarkSeen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageActionMarkSeen$Response(params: PostFeedbackManageActionMarkSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postFeedbackManageActionMarkSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeedbackManageActionMarkSeen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postFeedbackManageActionMarkSeen(params: PostFeedbackManageActionMarkSeen$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postFeedbackManageActionMarkSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `getFeedbackManageUnreadCount()` */
  static readonly GetFeedbackManageUnreadCountPath = '/api/feedback/manage/unread-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbackManageUnreadCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackManageUnreadCount$Response(params?: GetFeedbackManageUnreadCount$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackUnreadCountDto>> {
    return getFeedbackManageUnreadCount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedbackManageUnreadCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackManageUnreadCount(params?: GetFeedbackManageUnreadCount$Params, context?: HttpContext): Observable<PlatformApiResultOfFeedbackUnreadCountDto> {
    return this.getFeedbackManageUnreadCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfFeedbackUnreadCountDto>): PlatformApiResultOfFeedbackUnreadCountDto => r.body)
    );
  }

}
